import { type PropsWithChildren } from 'react';

import type { IndicatorsDisplay } from '../../../core/components/annotations/components/indicators/types.js';
import type { AnnotationsTrackProps } from '../../../core/components/annotations/types/annotations-track-props.js';

/**
 * TimeseriesChart Annotations.Track subcomponent props
 * @public
 */
export interface TimeseriesAnnotationsTrackProps extends AnnotationsTrackProps {
  /**
   * Defines how to show the annotations indicators: always, never, or on hover (auto) at Track level
   * @defaultValue 'auto'
   */
  indicatorsDisplay?: IndicatorsDisplay;
}

/**
 * @public
 */
export const Track = (
  props: PropsWithChildren<TimeseriesAnnotationsTrackProps>,
) => null;

Track['displayName'] = 'TimeseriesAnnotations.Track';
